import { Notice } from '../../Model/Notice';
import { NoticeRepository } from '../Repositories/NoticeRepository';

export class GetNoticeUseCase {
  constructor(private repo: NoticeRepository) {}
  execute(id: number): Promise<Notice> {
    return this.repo.get(id).then(r => r).catch(err => Promise.reject(err));
  }
}
